class VideoCarousel extends SlideshowComponent {
  constructor() {
      super();
      this.playButtons = this.querySelectorAll('.video-modal__modal-button.play-button')
      this.pauseButtons = this.querySelectorAll('.video-modal__modal-button.pause-button')
      this.closeButtons = this.querySelectorAll('.video-modal__close-button')
      this.nextButtons = this.querySelectorAll('.video-modal__next')
      this.videoElements = this.querySelectorAll('.video-modal > video')

      this.bindEvents();

      this.videoElements.forEach((video) => {
          video.addEventListener('ended', (event) => {
              this.resetVideo(video)
          });
      })

      this.enableSliderLooping = true;
      this.nextButtons.forEach((button) => {
          button.addEventListener('click', this.onButtonClick.bind(this));
      });
  }

  bindEvents() {
      // play videos
      this.playButtons.forEach(button => button.addEventListener('click', this.playVideo.bind(this)));

      // pause videos
      this.pauseButtons.forEach(button => button.addEventListener('click', this.pauseVideo.bind(this)));

      // close modals
      if (this.closeButtons) this.closeButtons.forEach(button => button.addEventListener('click', this.closeModal.bind(this)));

  }

  playVideo(event) {
      event.preventDefault();

      let parentModal = event.currentTarget.parentNode
      parentModal.querySelector('video').play();
      parentModal.classList.add('is-playing')
  }

  pauseVideo(event) {
      event.preventDefault();

      let parentModal = event.currentTarget.parentNode
      parentModal.querySelector('video').pause();
      parentModal.classList.remove('is-playing')
  }

  closeModal(event) {
      event.stopPropagation();
      event.preventDefault();
      event.currentTarget.closest('a').classList.remove('video-active')
  }

  resetVideo(el) {
      el.currentTime = 0;
      el.parentNode.classList.remove('is-playing')
  }
}

customElements.define('video-carousel', VideoCarousel);
